"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var form_component_1 = require("./form.component");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var zip_1 = require("rxjs/observable/zip");
var from_1 = require("rxjs/observable/from");
var of_1 = require("rxjs/observable/of");
var Subject_1 = require("rxjs/Subject");
var empty_1 = require("rxjs/observable/empty");
var noop_1 = require("rxjs/util/noop");
var ViewFormComponent = /** @class */ (function (_super) {
    __extends(ViewFormComponent, _super);
    function ViewFormComponent(_deService, _classifierService, _kbService, _actionService, _languageService, _currentLanguageProvider, _lockingService, _cookieService, _dePermissionService, _authenticationService) {
        var _this = _super.call(this, _deService, _classifierService, _kbService, _languageService, _currentLanguageProvider) || this;
        _this._deService = _deService;
        _this._classifierService = _classifierService;
        _this._kbService = _kbService;
        _this._actionService = _actionService;
        _this._languageService = _languageService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        _this._lockingService = _lockingService;
        _this._cookieService = _cookieService;
        _this._dePermissionService = _dePermissionService;
        _this._authenticationService = _authenticationService;
        /**
         * Logged in User Id
         * @type {any}
         * @private
         */
        _this._currentUserId = null;
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(ViewFormComponent.prototype, "dePermission", {
        get: function () {
            return this._dePermission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewFormComponent.prototype, "workflowActions", {
        get: function () {
            return this._workflowActions;
        },
        enumerable: true,
        configurable: true
    });
    ViewFormComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    /**
     * Loads and Initializes MainEntity
     * @param {number} instanceId - instanceId of mainEntity to load.
     */
    ViewFormComponent.prototype.loadViewFormData = function (instanceId) {
        var _this = this;
        var mainEntity$ = this.loadMainEntity(instanceId).pipe(operators_1.first());
        var currentLanguage$ = this._currentLanguageProvider.getCurrentLanguage();
        var userData$ = this._authenticationService.getUserData();
        combineLatest_1.combineLatest(mainEntity$, currentLanguage$, userData$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            var language = data[1];
            _this._currentLanguageId = language.getId();
            _this._currentUserId = +data[2].userId;
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    ViewFormComponent.prototype.onMainEntityLoaded = function () {
        return zip_1.zip(_super.prototype.onMainEntityLoaded.call(this), this.getDePermissions());
    };
    ViewFormComponent.prototype.edit = function () {
        var _this = this;
        var lockData$ = this._lockingService.getLock(this._systemName, this._mainEntity.getInstanceId());
        var permanentLockData$ = this._lockingService.getPermanentLock(this._systemName, this._mainEntity.getInstanceId());
        zip_1.zip(lockData$, permanentLockData$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            var lockData = data[0];
            var permanentLockData = data[1];
            if (lockData.getIsLocked() &&
                lockData.userId !== _this._currentUserId) {
                _this.navigateToLockErrorPage(lockData);
            }
            else if (permanentLockData.getIsLocked()) {
                _this.navigateToLockErrorPage(permanentLockData);
            }
            else {
                _this.navigateToEditPage();
            }
        }, function (err) { return console.error(err); });
    };
    /**
     * View form Delete functionality with permission checking
     */
    ViewFormComponent.prototype.delete = function () {
        var _this = this;
        this._lockingService
            .getLock(this._systemName, this._mainEntity.getInstanceId())
            .pipe(operators_1.switchMap(function (data) {
            if (data.getIsLocked() &&
                data.userId !== _this._currentUserId) {
                _this.navigateToLockErrorPage(data);
                return empty_1.empty();
            }
            else {
                return _this._deService.delete(_this._systemName, _this._mainEntity);
            }
        }), operators_1.map(function () {
            _this.onDeleteDone();
        }), operators_1.catchError(function (err) {
            console.error(err);
            return empty_1.empty();
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, console.error);
    };
    /**
     * After Deletion preparation logic
     */
    ViewFormComponent.prototype.onDeleteDone = function () {
        this.navigateToDeletePage();
    };
    /**
     * Preparation logic after workflow existence checking
     * @returns {Observable<any>}
     */
    ViewFormComponent.prototype.onWorkflowExistenceLoaded = function () {
        return this.getWorkflowActions();
    };
    /**
     * Do Workflow Action and changes the state correspondingly to action
     * @param {number} actionId - corresponding action which must be done
     */
    ViewFormComponent.prototype.doWorkflowAction = function (actionId) {
        var _this = this;
        if (this.hasWorkflow && actionId && actionId !== 0) {
            this._deService
                .doWorkflowAction(this._systemName, this._mainEntity, actionId)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (serviceResponse) {
                var validations = serviceResponse
                    .getMeta()
                    .getValidations();
                if (validations.length > 0) {
                    _this._validations = validations;
                }
                else {
                    _this._validations = [];
                    _this.onWorkflowActionDone(serviceResponse);
                }
            }, function (err) { return console.error(err); });
        }
        else if (!this.hasWorkflow) {
            throw new Error(this._systemName + " has no Workflow");
        }
    };
    /**
     * After Workflow Action done preparations
     * @param {ServiceResponse<MainEntity>} serviceResponse
     */
    ViewFormComponent.prototype.onWorkflowActionDone = function (serviceResponse) {
        var _this = this;
        this._mainEntity = serviceResponse.getData();
        this.getWorkflowActions()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (workflowActions) {
            _this._workflowActions = workflowActions;
        }, function (error1) { return console.error(error1); });
    };
    ViewFormComponent.prototype._setCurrentLanguageId = function () {
        var _this = this;
        this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (language) {
            _this._currentLanguageId = language.getId();
        }, function (error1) {
            console.error('An error occurred', error1);
        });
    };
    /**
     * Loads The workflow Actions ' list of current Workflow State
     * @returns {Observable<any>}
     */
    ViewFormComponent.prototype.getWorkflowActions = function () {
        var _this = this;
        if (this.hasWorkflow) {
            var actionPromise = this._actionService.getActionsByStateId(this.mainEntity
                .getProperty(this._workflowStateFieldName)
                .value.getId());
            return from_1.from(actionPromise).pipe(operators_1.map(function (actions) {
                _this._workflowActions = actions;
                return _this._workflowActions;
            }));
        }
        else {
            return of_1.of([]);
        }
    };
    /**
     * Gets de/details permissions based on user permissions from de-service
     */
    ViewFormComponent.prototype.getDePermissions = function () {
        var _this = this;
        return this._dePermissionService
            .getCategoryDePermissionsByInstance(this._systemName, this._mainEntity.getInstanceId())
            .pipe(operators_1.map(function (dePermission) {
            _this._dePermission = dePermission;
            return dePermission;
        }));
    };
    return ViewFormComponent;
}(form_component_1.FormComponent));
exports.ViewFormComponent = ViewFormComponent;
//# sourceMappingURL=view-form.component.js.map